import { createAction } from '@reduxjs/toolkit';
import { createActions } from '../lib';

import { ProjectRecord } from './state';
import {
  TRecommendedProject,
  TRecommendedProjectData,
  RecommendationPagination,
  TCarbonProjectData,
} from '../../types';

interface ProjectsLoadPayload {
  recommended?: {
    items: Array<TRecommendedProject>;
    total: {
      all: number;
      carbon_projects: number;
      recommendations: number;
      searched: number;
      saved: number;
    };
    pagination: {
      total: number;
      page: number;
      perPage: number;
    };
  };
  forestation?: Array<ProjectRecord>;
  carbon?: {
    items: Array<TCarbonProjectData>;
    total: {
      all: number;
      carbon_projects: number;
      recommendations: number;
      searched: number;
      saved: number;
    };
  };
  favorite?: {
    items: Array<any>;
    pagination: { total: number };
  };
}

export interface ProjectFilters {
  methodology?: Array<string>;
  type_id?: Array<string>;
  start_date?: string;
  end_date?: string;
  min_estimated_annual_emission_reduction?: number;
  max_estimated_annual_emission_reduction?: number;
  locations?: Record<string, unknown>;
}

export interface ProjectPagination {
  page: number;
  perPage: number;
}

export const loadProjectsSpecific = createActions<void, Partial<ProjectsLoadPayload>, string>(
  'projects/LOAD_PROJECTS_SPECIFIC',
);

export interface FilterValuesPayload {
  methodologies: Array<string>;
  types: Array<{ id: number; name: string }>;
  max_estimated_annual_emission_reduction: number;
}

export const loadFiltersValues = createActions<void, FilterValuesPayload, string>(
  'projects/LOAD_FILTERS_VALUES',
);

export const changeSelectedTypeAction = createAction<
  'recommendation' | 'current' | 'saved',
  string
>('projects/CHANGE_PROJECT_TYPE');

export const changeSearchLocationAction = createAction<{
  level: number;
  id: string;
  name: string;
} | null>('projects/CHANGE_SEARCH_LOCATION_ACTION');

export const changeSearchAction = createAction<string>('projects/CHANGE_SEARCH_ACTION');

export const changeFilterAction = createAction<Partial<ProjectFilters>>(
  'projects/CHANGE_FILTER_ACTION',
);

export const changePaginationAction = createAction<Partial<ProjectPagination>>(
  'projects/CHANGE_PAGINATION_ACTION',
);

export const resetFilterAction = createAction('projects/RESET_FILTER');

export const changeViewModeAction = createAction<'list' | 'grid'>('projects/CHANGE_VIEW_MODE');

export const setMangroveViewModeAction = createAction<'districts' | 'aggregations'>(
  'projects/SET_MANGROVE_VIEW_MODE',
);

export const setSelectedRecommendedAction = createAction<TRecommendedProjectData | undefined>(
  'projects/SET_SELECTED_RECOMMENDED',
);

export const setSelectedRecommendationTypeAction = createAction<string>(
  'projects/SET_SELECTED_RECOMMENDADTION_TYPE',
);

export const setAllCarbonProjectsAction = createAction<Array<TCarbonProjectData>>(
  'projects/SET_ALL_CARBON_PROJECTS',
);

export const setCurrentDataLayerType = createAction<string>('projects/SET_CURRENT_DATA_LAYER');

export const setCurrentSkippedItems = createAction<number>('projects/CURRENT_SKIPPED_ITEMS');

export interface GeoRasterData {
  data: unknown;
  isLoading: boolean;
}

export const setCurrentGeoRasterData = createAction<GeoRasterData>(
  'projects/SET_CURRENT_GEORASTER',
);

export const setRecommendationPagination = createAction<RecommendationPagination>(
  'projects/SET_RECOMMENDATION_PAGINATION',
);
